<template>
  <TopNav></TopNav>
  <h1>Gelir Vergisi Hesaplama</h1>
  <fieldset>
    <legend>Gelir Vergisi Hesaplama Aracı</legend>
    <label for="mukellefTuru" class="leftLabel">Mükellef Türü:</label>
    <select name="mukellefTuru" id="mukellefTuru" v-model="mukellefTuru">
      <option value="ucretli">Ücretli</option>
      <option value="ucretDisi">Ücret Dışı</option>
    </select>
    <br>
    <label for="donem" class="leftLabel">Dönem:</label>
    <select name="donem" id="donem" v-model="donem">
      <option value="2022">2022</option>
      <option value="2023">2023</option>
      <option value="2024">2024</option>
      <option value="2025">2025</option>
    </select>
    <br>
    <br>
    <label for="vergiMatrahi" class="leftLabel">Vergi Matrahı:</label>
    <input type="number" v-model.number="inputVergiMatrahi" id="vergiMatrahi" step="any" min="0"> <label for="vergiMatrahi"><abbr title="Türk Lirası">₺</abbr></label>
    <br><br>
    Ödenecek Gelir Vergisi: <span class="blue">{{ odenecekGelirVergisi() }} ₺</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "GelirVergisi",
  data() {

    let vergiDilimleri = [];
    vergiDilimleri[2022] = [];
    vergiDilimleri[2022]["ucretli"] = [];

    vergiDilimleri[2022]["ucretli"][-1] = [0, 0];
    vergiDilimleri[2022]["ucretli"][0] = [32000, 0.15];
    vergiDilimleri[2022]["ucretli"][1] = [70000, 0.20];
    vergiDilimleri[2022]["ucretli"][2] = [250000, 0.27];
    vergiDilimleri[2022]["ucretli"][3] = [880000, 0.35];
    vergiDilimleri[2022]["ucretli"][4] = [Infinity, 0.40];

    vergiDilimleri[2022]["ucretDisi"] = [];

    vergiDilimleri[2022]["ucretDisi"][-1] = [0, 0];
    vergiDilimleri[2022]["ucretDisi"][0] = [32000, 0.15];
    vergiDilimleri[2022]["ucretDisi"][1] = [70000, 0.20];
    vergiDilimleri[2022]["ucretDisi"][2] = [170000, 0.27];
    vergiDilimleri[2022]["ucretDisi"][3] = [880000, 0.35];
    vergiDilimleri[2022]["ucretDisi"][4] = [Infinity, 0.40];


    vergiDilimleri[2023] = [];
    vergiDilimleri[2023]["ucretli"] = [];

    vergiDilimleri[2023]["ucretli"][-1] = [0, 0];
    vergiDilimleri[2023]["ucretli"][0] = [70000, 0.15];
    vergiDilimleri[2023]["ucretli"][1] = [150000, 0.20];
    vergiDilimleri[2023]["ucretli"][2] = [550000, 0.27];
    vergiDilimleri[2023]["ucretli"][3] = [1900000, 0.35];
    vergiDilimleri[2023]["ucretli"][4] = [Infinity, 0.40];

    vergiDilimleri[2023]["ucretDisi"] = [];

    vergiDilimleri[2023]["ucretDisi"][-1] = [0, 0];
    vergiDilimleri[2023]["ucretDisi"][0] = [70000, 0.15];
    vergiDilimleri[2023]["ucretDisi"][1] = [150000, 0.20];
    vergiDilimleri[2023]["ucretDisi"][2] = [370000, 0.27];
    vergiDilimleri[2023]["ucretDisi"][3] = [1900000, 0.35];
    vergiDilimleri[2023]["ucretDisi"][4] = [Infinity, 0.40];


    vergiDilimleri[2024] = [];
    vergiDilimleri[2024]["ucretli"] = [];

    vergiDilimleri[2024]["ucretli"][-1] = [0, 0];
    vergiDilimleri[2024]["ucretli"][0] = [110000, 0.15];
    vergiDilimleri[2024]["ucretli"][1] = [230000, 0.20];
    vergiDilimleri[2024]["ucretli"][2] = [870000, 0.27];
    vergiDilimleri[2024]["ucretli"][3] = [3000000, 0.35];
    vergiDilimleri[2024]["ucretli"][4] = [Infinity, 0.40];

    vergiDilimleri[2024]["ucretDisi"] = [];

    vergiDilimleri[2024]["ucretDisi"][-1] = [0, 0];
    vergiDilimleri[2024]["ucretDisi"][0] = [110000, 0.15];
    vergiDilimleri[2024]["ucretDisi"][1] = [230000, 0.20];
    vergiDilimleri[2024]["ucretDisi"][2] = [580000, 0.27];
    vergiDilimleri[2024]["ucretDisi"][3] = [3000000, 0.35];
    vergiDilimleri[2024]["ucretDisi"][4] = [Infinity, 0.40];


    vergiDilimleri[2025] = [];
    vergiDilimleri[2025]["ucretli"] = [];

    vergiDilimleri[2025]["ucretli"][-1] = [0, 0];
    vergiDilimleri[2025]["ucretli"][0] = [158000, 0.15];
    vergiDilimleri[2025]["ucretli"][1] = [330000, 0.20];
    vergiDilimleri[2025]["ucretli"][2] = [1200000, 0.27];
    vergiDilimleri[2025]["ucretli"][3] = [4300000, 0.35];
    vergiDilimleri[2025]["ucretli"][4] = [Infinity, 0.40];

    vergiDilimleri[2025]["ucretDisi"] = [];

    vergiDilimleri[2025]["ucretDisi"][-1] = [0, 0];
    vergiDilimleri[2025]["ucretDisi"][0] = [158000, 0.15];
    vergiDilimleri[2025]["ucretDisi"][1] = [330000, 0.20];
    vergiDilimleri[2025]["ucretDisi"][2] = [800000, 0.27];
    vergiDilimleri[2025]["ucretDisi"][3] = [4300000, 0.35];
    vergiDilimleri[2025]["ucretDisi"][4] = [Infinity, 0.40];

    return {
      mukellefTuru: "ucretli",
      donem: 2025,
      inputVergiMatrahi: 0,
      vergiDilimleri: vergiDilimleri
    }
  },
  components: {
    TopNav
  },
  methods: {
    odenecekGelirVergisi: function () {
      var para = this.inputVergiMatrahi;
      var vergi = 0;
      for (var i = 0; i < this.vergiDilimleri[this.donem][this.mukellefTuru].length; i++) {
        if (para <= this.vergiDilimleri[this.donem][this.mukellefTuru][i][0]) {
          let oran = this.vergiDilimleri[this.donem][this.mukellefTuru][i][1];
          let fark = para - this.vergiDilimleri[this.donem][this.mukellefTuru][i - 1][0];
          let carpimSonucu = fark * oran;
          vergi = vergi + carpimSonucu;
          break;
        } else {
          let orani = this.vergiDilimleri[this.donem][this.mukellefTuru][i][1];
          let siniri = this.vergiDilimleri[this.donem][this.mukellefTuru][i][0];
          let index = i - 1;
          let oncekiSiniri = this.vergiDilimleri[this.donem][this.mukellefTuru][index][0];
          vergi += (siniri - oncekiSiniri) * orani;
        }
      }

      let vergiNumara = Number(vergi);
      return vergiNumara.toLocaleString('tr-TR');
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
  display: inline-block;
  min-width: 130px;
}

.olumlu {
  color: #008A00;
}

.olumsuz {
  color: #EB0000;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
